<!-- Den här koden är knyckt från https://scotch.io/tutorials/how-to-handle-file-uploads-in-vue-2 -->
<!-- HTML Template -->
<template>
	<div id="app">
		<div class="container">
			<!--UPLOAD-->
			<form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
				<div class="dropbox">
					<p v-if="isInitial">
						Släpa dina filer hit för att påbörja uppladdning<br> eller klicka här för att välja fil.
					</p>
					<p v-if="isSaving">
						Laddar upp {{ fileCount }} fil...
					</p>
					<input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept=".csv" class="input-file">

				</div>
			</form>
		</div>
	</div>
</template>

<!-- Javascript -->
<script>
	'use strict';

	import * as axios from 'axios';

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

	export default {

		name: 'eui-upload',
		data() {
			return {
				uploadedFiles: [],
				uploadError: null,
				currentStatus: null,
				fileCount: 0,
				uploadFieldName: 'files'
			}
		},
		computed: {
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			}
		},
		methods: {
			reset() {
				// reset form to initial state
				this.currentStatus = STATUS_INITIAL;
				this.uploadedFiles = [];
				this.uploadError = null;
			},
			save(formData) {
				// upload data to the server
				this.currentStatus = STATUS_SAVING;

				axios.post('/upload', formData)
					.then(response => {
						console.log('upload response: ' + response.data.success);
						//this.uploadedFiles = [].concat(response.data);

						if (!response.data.success) {
							this.uploadError = response.data.error;
							this.currentStatus = STATUS_FAILED;
							console.error(response.data.error);
							alert('Fel vid uppladdning: ' + response.data.error);
						}
						else {
							this.currentStatus = STATUS_SUCCESS;

							// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
							this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

							window.location.href = '/avstamning';  // Go to match page
						}
					})
					.catch(e => {
						this.uploadError = e.response;
						this.currentStatus = STATUS_FAILED;
						console.error(e);
						alert('Fel vid uppladdning: ' + e);
					});

				console.log('save called');

			},
			filesChange(fieldName, fileList) {
				// handle file changes

				const formData = new FormData();

				// append the files to FormData
				Array
					.from(Array(fileList.length).keys())
					.map(x => {
						formData.append(fieldName, fileList[x], fileList[x].name);
					});

				this.fileCount = fileList.length;

				// save it
				this.save(formData);
			}
		},
		mounted() {
			this.reset();
		},
	}

</script>

<!-- Styling -->
<style lang="css">
	.dropbox {
		outline: 2px dashed grey; /* the dash box */
		outline-offset: -10px;
		background: lightcyan;
		color: dimgray;
		padding: 10px 10px;
		min-height: 200px; /* minimum height */
		position: relative;
		cursor: pointer;
	}

	.input-file {
		opacity: 0; /* invisible but it's there! */
		width: 100%;
		height: 200px;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
	}

	.dropbox:hover {
		background: lightblue; /* when mouse over to the drop zone, change color */
	}

	.dropbox p {
		font-size: 1.2em;
		text-align: center;
		padding: 50px 0;
	}
</style>
